import { Link } from "react-router-dom";
import { Instagram, Mail, ArrowUpRight } from "lucide-react";
import { SITE, NAV_LINKS } from "@/constants/site";
import { FOOTER } from "@/constants/testIds";

const Footer = () => {
  return (
    <footer
      data-testid={FOOTER.root}
      className="section-rule bg-[#0A0A0A] text-white"
    >
      <div className="mx-auto max-w-[1440px] px-5 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6">
          <div className="md:col-span-6">
            <div className="num-tag mb-4">/ END · CTA</div>
            <h2 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight uppercase">
              Let's work.
              <br />
              <span className="stroke-fire">Your journey.</span>
              <br />
              Our mission.
            </h2>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/contact" className="btn-fire">
                Start Now
                <ArrowUpRight size={18} />
              </Link>
              <a
                href={SITE.instagramUrl}
                target="_blank"
                rel="noreferrer"
                className="btn-ghost"
                data-testid={FOOTER.instagram}
              >
                DM {SITE.instagramHandle}
                <Instagram size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <div className="num-tag mb-4">/ Navigate</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="group inline-flex items-center gap-2 font-display text-2xl uppercase text-zinc-300 hover:text-[#FF4D00] transition-colors"
                  >
                    <span>{l.label}</span>
                    <ArrowUpRight
                      size={16}
                      className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform]"
                    />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="num-tag mb-4">/ Direct</div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={SITE.instagramUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-zinc-300 hover:text-[#FF4D00] transition-colors"
                >
                  <Instagram size={14} />
                  {SITE.instagramHandle}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${SITE.ownerEmail}`}
                  data-testid={FOOTER.email}
                  className="inline-flex items-center gap-2 text-zinc-300 hover:text-[#FF4D00] transition-colors"
                >
                  <Mail size={14} />
                  {SITE.ownerEmail}
                </a>
              </li>
            </ul>
            <div className="mt-8">
              <img
                src={SITE.logo}
                alt=""
                className="w-24 h-24 rounded-full opacity-80"
              />
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="font-mono-plex text-[10px] tracking-[0.28em] text-zinc-500 uppercase">
            © {new Date().getFullYear()} TWGAS Athletics &amp; Development LLC
          </div>
          <div className="font-mono-plex text-[10px] tracking-[0.28em] text-zinc-500 uppercase">
            The Work Gone Always Show.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
